import React from "react";
import { Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { ErrorContainer } from "./styles";
import { ContentConditional } from "@/components/content-conditional";

interface PageErrorProps {
  message: string;
  display: boolean;
}

export const PageError: React.FC<PageErrorProps> = ({
  message,
  display = false
}) => (
  <ContentConditional.IsShow isShow={display}>
    <ErrorContainer>
      <ErrorOutlineIcon color="error" sx={{ fontSize: 24 }} />
      <Typography variant="body1" color="error" align="center">
        {message}
      </Typography>
    </ErrorContainer>
  </ContentConditional.IsShow>
);
